import React from 'react';
import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';


// The building blocks the Services pages (Fractional CTO, Engineering Sprints)
// share, so the two read as one offering rather than two sites.

export const CONTACT_EMAIL = 'hello@codescribes.io';

// Every call to action on the Services pages is an email. The subject tells
// the inbox which page and which button it came from.
export const contactHref = (subject) => `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}`;


// Client work both Services pages draw on: what was built (`body`) and what
// it changed (`outcome`), with `summary` as the one-liner used in lists. Keep
// each to work that actually used AI, and never name the client.
export const CASE_STUDIES = [
  {
    id: 'agentic-workflow',
    title: 'Agentic Workflow',
    body: 'Built onboarding workflows that use LLMs to agentically handle the manual work of onboarding new clients: collecting client information, verifying the data, and giving personalized guidance throughout the process.',
    outcome: 'Onboarding became faster and easier for clients and administrators alike.',
    summary: 'Agentic onboarding workflows that collect and verify client information and guide each new client through the process'
  },
  {
    id: 'mcp-server',
    title: 'MCP Server',
    body: 'Built an MCP server that wraps 700+ API endpoints in ~40 tools designed around common data access patterns, available through a chat interface.',
    outcome: 'Non-technical users query their data in plain language, with no REST APIs or SQL required.',
    summary: 'An MCP server wrapping 700+ API endpoints in ~40 tools, so non-technical users query their data in plain language'
  },
  {
    id: 'ai-integration',
    title: 'AI Integration',
    body: "Set up agents, for branding, finance, and employee onboarding plus a 14+ data connectors, including MCP servers, across one client's business systems.",
    outcome: 'Every non-technical user can hand routine work off to AI and get more done.',
    summary: '3 agents and a 14+ data connectors that let every non-technical user hand routine work off to AI'
  }
];


export const formatUsd = (amount) => `$${amount.toLocaleString('en-US')}`;


export const Overline = ({ children, className }) => {
  return (
    <p className={classNames('mb-3 font-body text-xs uppercase tracking-widest text-primary-light', className)}>
      {children}
    </p>
  );
};


export const PrimaryButton = ({ href, children }) => {
  // Only web links leave the site; a mailto opens the mail app in place.
  const external = href.startsWith('http');

  return (
    <a
      href={href}
      target={external ? '_blank' : undefined}
      rel={external ? 'noreferrer' : undefined}
      className={classNames(
        'inline-flex h-11 items-center justify-center gap-2.5 rounded-lg bg-primary px-6 font-body text-[15px] tracking-wide text-white shadow-sm',
        'transition-colors duration-150 hover:bg-primary-light',
        'focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 focus:ring-offset-neutral-950'
      )}
    >
      {children}
      {external && <FontAwesomeIcon icon={faArrowUpRightFromSquare} size='sm' className='opacity-80' />}
    </a>
  );
};


export const OutlineButton = ({ href, children }) => {
  return (
    <a
      href={href}
      className={classNames(
        'inline-flex h-11 items-center justify-center gap-2.5 rounded-lg border border-neutral-700 px-6 font-body text-[15px] tracking-wide text-primary-light',
        'transition-colors duration-150 hover:border-neutral-500 hover:text-primary-foreground',
        'focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 focus:ring-offset-neutral-950'
      )}
    >
      {children}
    </a>
  );
};
